"use server";
import { redirect } from "next/navigation";
import { logInWithEmail, signUpWithEmail, requestPasswordReset, resetPassword } from "@/lib/auth";
import { createSession, destroySession } from "@/lib/session";
import { hosts } from "@/lib/env";

export type FormState = { error?: string; done?: string; email?: string };

export async function signUpAction(_: FormState, fd: FormData): Promise<FormState> {
  const email = String(fd.get("email") ?? "");
  const r = await signUpWithEmail(email, String(fd.get("password") ?? ""), String(fd.get("name") ?? ""));
  if (!r.ok) return { error: r.error, email };
  await createSession(r.userId);
  redirect("/welcome");
}

export async function logInAction(_: FormState, fd: FormData): Promise<FormState> {
  const email = String(fd.get("email") ?? "");
  const r = await logInWithEmail(email, String(fd.get("password") ?? ""));
  if (!r.ok) return { error: r.error, email };
  await createSession(r.userId);
  const next = String(fd.get("next") || "");
  redirect(next.startsWith("/") || next.startsWith(hosts.admin) ? next : "/today");
}

export async function forgotAction(_: FormState, fd: FormData): Promise<FormState> {
  await requestPasswordReset(String(fd.get("email") ?? ""));
  return { done: "If that email has an account, a reset link is on its way." };
}

export async function resetAction(_: FormState, fd: FormData): Promise<FormState> {
  const r = await resetPassword(String(fd.get("token") ?? ""), String(fd.get("password") ?? ""));
  if (!r.ok) return { error: r.error };
  await createSession(r.userId);
  redirect("/today");
}

export async function logOutAction() {
  await destroySession();
  redirect("/login");
}
